import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import App from './App';
import store from './redux/store';
import './fonts.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {initErrorReporting, initGameAnalytics, sendAppEvent} from './analytics/gameAnalytics';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import {checkAppVersion, startPeriodicVersionCheck} from './utils/version/checkVersion';
import {initBootTrace} from './utils/debug/bootTrace';
import {traceAudioVolumeSupport} from './utils/sound/audioElementVolume';
import {initAppInstallPrompt} from './utils/pwa/appInstall';
import {runDevAutoLogin} from './utils/debug/devAutoLogin';

// Трассировка старта (?bootTrace=1) — раньше всего остального, чтобы поймать
// и падения самой инициализации
initBootTrace();
// Перехват beforeinstallprompt — до первого рендера: событие приходит вскоре
// после загрузки страницы, и подписка из компонента меню его бы не застала
initAppInstallPrompt();
// Как именно платформа обходится с громкостью (ничего не делает без ?bootTrace=1)
traceAudioVolumeSupport();
initGameAnalytics();
// Ловушки ошибок — сразу после инициализации SDK, до всего остального: падение
// в любом коде ниже должно попасть в статистику, а не пропасть молча
initErrorReporting();
// Бандл выполнился. Разрыв между этим событием и app:render означает, что
// приложение не доехало до первого экрана (см. App)
sendAppEvent('boot');
checkAppVersion();
startPeriodicVersionCheck();

// Картинки-заглушки LoadedImage (магазин, инвентарь, все обличия) — греем кэш
// в самой точке входа, до монтирования React: заглушка полезна, только если
// сама уже загружена к моменту, когда начали грузиться настоящие картинки.
// Прогрев в MainMenu (иконки табов магазина) остается — он покрывает возврат
// после долгой сессии, а этот гарантирует готовность с самого первого экрана
['/img/icons/banner.png', '/img/icons/chest.png'].forEach((placeholderSrc) => {
  const img = new Image();
  img.src = placeholderSrc;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// ?devLogin=<ник> — только в npm start: cookie должна встать до первого
// запроса /auth/me из App
runDevAutoLogin().finally(() => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <App/>
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  );
});

serviceWorkerRegistration.register();
